import * as BABYLON from "babylonjs"
import * as GUI from "babylonjs-gui"

export class RangeSlider {
	static create(
		scene: BABYLON.Scene,
		id: string,
		position: [number, number, number],
		size: [number, number], // [width, height] in 3D world units
		min: number,
		max: number,
		value: number,
		onValueChanged: (newValue: number) => void,
		grabbable: boolean = false,
		visibility: boolean,
		orientation: "horizontal" | "vertical",
		colour: string,
		accentColour1: string,
		parentID?: string // New parameter for parent ID
	): void {
		const plane = BABYLON.MeshBuilder.CreatePlane(
			`${id}_plane`,
			{ width: size[0], height: size[1] },
			scene
		)
		plane.position = new BABYLON.Vector3(position[0], position[1], position[2])

		if (orientation == "vertical") plane.rotation.z = Math.PI // Rotate 90 degrees around the X-axis

		// Create an advanced texture that will be used as the GUI container

		plane.material = new BABYLON.PBRMaterial("materialPlane", scene)

		const advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(plane)

		// Create the slider
		const slider = new GUI.Slider()
		slider.minimum = min
		slider.maximum = max
		slider.value = value
		slider.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER
		slider.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER
		slider.height = "40%"
		slider.width = "100%"
		slider.color = colour
		slider.background = accentColour1

		// Set slider dimensions based on orientation
		if (orientation === "vertical") {
			slider.width = "40%" // Thinner for vertical
			slider.height = "100%" // Height represents the length in vertical orientation
			//slider.thumbImage = "100%"
			slider.isVertical = true // Make the slider vertical
		} else {
			// 'horizontal'
			slider.width = "100%" // Width represents the length in horizontal orientation
			slider.height = "40%" // Thinner for horizontal
			slider.isVertical = false // Keep the slider horizontal (default)
		}

		slider.onValueChangedObservable.add((newValue) => {
			onValueChanged(newValue)
		})

		// Add the slider to the advanced texture
		advancedTexture.addControl(slider)
		// Setting the parent if parentID is provided
		if (parentID) {
			const parentMesh = plane._scene!.getMeshByID(parentID) as BABYLON.Mesh
			if (parentMesh) {
				plane.parent = parentMesh
			}
		}
		if (grabbable) {
			// Instead of PointerDragBehavior, use SixDofDragBehavior for 3D dragging
			const dragBehavior = new BABYLON.SixDofDragBehavior()
			plane.addBehavior(dragBehavior)

			dragBehavior.onDragStartObservable.add(() => {
				console.log("3D dragging started")
			})
			// No onDragObservable here, SixDofDragBehavior does not provide continuous updates like PointerDragBehavior
			dragBehavior.onDragEndObservable.add(() => {
				console.log("3D dragging ended")
			})
		}
		plane.isVisible = visibility
		plane.renderingGroupId = 2
	}
}
